import Image from "next/image";
import { formatStrapiEntity, StrapiEntity, StrapiImage } from "@/utils/strapi";
import { addBasePathToStrapiMedia } from "@/utils/strapi";
import styles from "./Item.module.scss";

export type ItemProps = {
  label: string;
  icon: StrapiEntity<StrapiImage>;
};

export const Item = ({ label, icon }: ItemProps) => {
  const strapiImage = formatStrapiEntity(icon);

  return (
    <div className={styles.item}>
      <div className={styles.iconContainer}>
        <Image
          src={addBasePathToStrapiMedia(strapiImage)}
          objectFit="contain"
          objectPosition="center"
          alt={strapiImage.alternativeText ?? ""}
          layout="fill"
        />
      </div>
      <div className={styles.label}>{label}</div>
    </div>
  );
};
